import * as dayjs from "dayjs";

export function getYearsModified(mod) {
    let date = dayjs().add(mod, 'year')
    if (mod < 0) date = date.startOf('year')
    else date = date.endOf('year')
    return date.format('YYYY-MM-DD');
}

//===========================================================
export function is_overlapse(a_start, a_end, b_start, b_end) {
    if (a_start.unix() > b_start.unix() && a_start.unix() < b_end.unix())
        return true;
    if (a_end.unix() > b_start.unix() && a_end.unix() < b_end.unix())
        return true;
    if (b_start.unix() > a_start.unix() && b_end.unix() < a_end.unix())
        return true;
    if (a_start.unix() == b_start.unix() || a_end.unix() == b_end.unix())
        return true;
    return false;
}
//===========================================================
export function is_set_overlapse(time_slot_set) {
    let result = false;
    for (let i = 0; i < time_slot_set.length; i++) {
        const element_i = time_slot_set[i];
        for (let j = i + 1; j < time_slot_set.length; j++) {
            const element_j = time_slot_set[j];

            let current_result = true;
            if(element_i.subject_id === element_j.subject_id) {
                current_result = false;
            }
            else {
                current_result = is_overlapse(
                    element_i.start_date_time,
                    element_i.end_date_time,
                    element_j.start_date_time,
                    element_j.end_date_time
                );
            }
            result = result || current_result;
            if (result) return true;
        }
    }
    return result;
}
//===========================================================
export function db_datetime_to_dayjs(str) {
    if(str && str.length === 19) return dayjs(str, 'YYYY-MM-DD HH:mm:ss');
    return null;
}